import { trySetProp } from "../../global.functions";
import { Organisation } from "../../model/organisation.model";


export interface IGetOrganisationResponse {
    success: string;
    organisation: Organisation;
    organisationFullUrl: string;
}

export class GetOrganisationResponse
{
    success: string;
    organisation: Organisation;
    organisationFullUrl: string;

    constructor(data?: IGetOrganisationResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any): this {
        if (_data) {
            trySetProp(this, _data, 'Success');
            trySetProp(this, _data, 'organisationFullUrl');
            if (_data["organisation"]) {
                this.organisation = Organisation.fromJS(_data["organisation"]);
            }
        }

        return this;
    }

    static fromJS(data: any): GetOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationResponse();
        result.init(data);
        return result;
    }
}

export interface IGetOrganisationListResponse {
    success: string;
    organisations: Organisation[];
    orgsWithAvailableProducts: string[];
}

export class GetOrganisationListResponse {
    success: string;
    organisations: Organisation[];
    orgsWithAvailableProducts: string[];

    constructor(data?: IGetOrganisationListResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.orgsWithAvailableProducts = _data["OrgsWithAvailableProducts"];
            let orgs = [];
            if (_data["Organisations"]) {
                _data["Organisations"].forEach((org: any) => {
                    orgs.push(Organisation.fromJS(org));
                });
            }

            this.organisations = orgs;
        }
    }

    static fromJS(data: any): GetOrganisationListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationListResponse();
        result.init(data);
        return result;
    }
}

export class OrganisationDbModel {
    id: string;
    formId: string;
    formVersion?: number | undefined;
    userId: string;
    respJson: any;

    init(formId: string, formVersion: number | undefined, userId: string, respJson: any): OrganisationDbModel {
        this.id = `${formId}_${formVersion}_${userId}`;
        this.formId = formId;
        this.userId = userId;
        this.formVersion = formVersion;
        this.respJson = respJson;
        return this;
    }
}
